import React, {useEffect, useRef, useState} from 'react';
import MaterialTable from 'material-table';
import { NavLink } from 'react-router-dom';
import { TablePagination } from '@material-ui/core';
import Cookies from 'js-cookie';
import CircularProgress from '@material-ui/core/CircularProgress';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes} from '@fortawesome/free-solid-svg-icons';
import { clearCookie } from '../../functions/Auth';
import { useHistory } from 'react-router-dom';
import { MoreVertRounded } from '@material-ui/icons';
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import TableIcons from '../TableIcons';

import API_PATH from "../../constants/config.json";
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

const UsersInGroup = (props) =>{

    let history = useHistory();
    const [userList, setUserList] = React.useState([]);
    const [pagination, setPagnation] = React.useState({ selectedPage: 1 });
    const [totalItems, setTotalItems] = React.useState(0);
    const [userAccess, setUserAccess] = React.useState(true);
    const [getLoader,setLoaderDisable] = React.useState(false);
    const [hover, setHower] = React.useState(false);
    const [getSearchTerm, setSearchTerm] = React.useState("");
    const refContainer = useRef('');
    const tableRef = useRef();

    let today = new Date();
    today.setDate(today.getDate()-14);
    const enteriesPerPage = 25;
    let values = {
        "pageNo": pagination.selectedPage,
        "entriesPerPage": enteriesPerPage,
    }

    useEffect(
        () => {
            if(props.needToReload) {
                if(getSearchTerm !== "")
                    getUsersAPI(1, getSearchTerm, true);
                else 
                    getUsersAPI();
            }
        }, [props.needToReload]
    )

    const getUsersAPI = (page = 1, search = "", enable = false) => { 
        setLoaderDisable(true);
        try {
          axios({
            method: 'post',
            data: {
              teamId: parseInt(sessionStorage.getItem('teamId')),
              pageNo: page,
              entriesPerPage: enteriesPerPage,
              searchEnable: enable,
              searchValue: search
            },
            headers: {
              'payload': Cookies.get('payload'),
              'agencyid': sessionStorage.getItem('agency_id')
            },
            url: API_URL + API_PATH.getusersbyteam,
          })
            .then(async function (response) {
              if (response.status && response.status == '200') {
                setLoaderDisable(false);
                let rows = response.data.data.rows;
                rows.forEach( (row, ind) => {
                    let tmpdt = new Date(row.created_date);
                    if(tmpdt.getTime() >= today.getTime()) {
                        rows[ind].new = true;
                    } else {
                        rows[ind].new = false;
                    }
                });
                setUserList(rows);
                setTotalItems(response.data.data.count);
              } else {
                setLoaderDisable(false);
                setUserList([]);
              }
    
            })
            .catch(async function (error) {
              if (error.response) {
                if (error.response.status && error.response.status == '401') {
                  if (Cookies.get('email')) {
                    clearCookie('email');
                    clearCookie('payload');
                    clearCookie('idToken');
                    clearCookie('organization');
                    clearCookie('atexpiry');
                  }
                  history.push('/');
                } else if (error.response.data && error.response.data.status && error.response.data.status == 403) {
                  setUserAccess(false);
                  setLoaderDisable(false);
                  setUserList([]);
                } else {
                  setLoaderDisable(false);
                  setUserList([]);
                }
              } else {
                setLoaderDisable(false);
                setUserList([]);
              }
    
            })
        } catch (error) {
          console.error(error);
        }
    }

    const handleSelected = (e, selectedPage) => {
        values.pageNo = selectedPage + 1;
        let page = values.pageNo
        setPagnation({ selectedPage: selectedPage + 1 })
        getUsersAPI(page);
    }

    const kekPressSearch = (e) => {    
        if(e.key === 'Enter'){
          e.preventDefault();
          onSearch();
        }    
    }

    const searchField = (e) => {
        setHower(true)    
        setSearchTerm(e.target.value);   
        getUsersAPI(1, e.target.value, true)
        setPagnation({ selectedPage: 1 })    
    }

    const onSearch = () => {   
        if(getSearchTerm == ''){      
            return;
        }
        getUsersAPI(1, getSearchTerm, true)
        setPagnation({ selectedPage: 1 })
    }

    const clearText = () => {
        refContainer.current.reset();
        setSearchTerm('');
        getUsersAPI();
    }

    return(
        <React.Fragment>  
            <div className="table-top">
                <h3>{props.groupName} - users</h3>
                <form ref={refContainer} noValidate autoComplete="off">
                    <TextField
                    id="input-with-icon-textfield"
                    placeholder="Search"
                    onChange={(e) => searchField(e)}
                    onKeyPress={(e) => kekPressSearch(e)}
                    InputProps={{
                        startAdornment: (
                        <InputAdornment position="start" onClick={onSearch}>
                            <SearchIcon style={{ cursor: 'pointer' }} />
                        </InputAdornment>
                        ),
                        endAdornment: (
                        <InputAdornment position="end">
                            {hover && <FontAwesomeIcon icon={faTimes} onClick={clearText} />}
                        </InputAdornment>
                        ),
                    }}

                    />      
                    
                </form>
            </div>   
            <div className={props.scrolled ? "table-container scrolled-el" : "table-container"} onScroll={() => props.handleScroll(tableRef)} ref={tableRef}>
                <MaterialTable
                    icons={TableIcons}
                    title=""
                    columns={[
                    { title: 'Name', field: 'first_name', width: '25%',
                        render: rowData => 
                        <NavLink to="#" onClick={()=> props.handleUserDetails(rowData.user_id, rowData.status)}>
                            {rowData.first_name+' '+rowData.last_name}
                            {rowData.new && <label className="active-lbl">New</label>}
                        </NavLink> 
                    },
                    { title: 'Email', field: 'email', width: '30%' },
                    { title: 'Organization', field: 'organization', width: '20%', },
                    { title: 'Status', field: 'status', width: '15%', 
                        render: rowData =>
                        <label className={rowData.status === 'active' ? "active-lbl" : "disabled-lbl"}>{rowData.status}</label>
                    },
                    { title: 'Actions', field: '', width: '10%', cellStyle: { textAlign: 'center' },
                        render: rowData => 
                        <MoreVertRounded className="actions-dots" onClick={(e) => props.handleShowActions(e,rowData.user_id, rowData.first_name, rowData.last_name, rowData.status)} /> 
                    },
                    ]}
                    data={userList ? userList : []}
                    totalCount={totalItems}
                    options={{
                        filtering: false,
                        sorting: false,
                        // paging: true,
                        paging: totalItems > 25 ? true : false,
                        pageSize: enteriesPerPage,
                        pageSizeOptions: [0],
                        search:false,
                        emptyRowsWhenPaging: false,
                        draggable: false
                    }}
                    components={
                        userAccess == true ?
                        getLoader == false?
                        {
                            Pagination: props => (
                                <TablePagination
                                {...props}
                                count={totalItems}
                                page={pagination.selectedPage - 1}
                                onChangePage={handleSelected}
                                rowsPerPage={enteriesPerPage}
                                />
                            ),
                            }
                            :
                            {
                                Pagination: props => (
                                <TablePagination
                                    {...props}
                                    count={totalItems}
                                    page={pagination.selectedPage - 1}
                                    onChangePage={handleSelected}
                                    rowsPerPage={enteriesPerPage}
                                />
                                ),
                                Body: (props) => (
                                <tbody><tr style={{ height: '49px' }}><td colspan="5" style={{ width: '100%', paddingTop: '0px', paddingBottom: '0px', textAlign: 'center' }}><span style={{ color: '#CC0000', fontWeight: '600' }}><CircularProgress/></span> </td></tr></tbody>
                                )
                            }
                        : {
                            Pagination: props => (
                                <TablePagination
                                {...props}
                                count={totalItems}
                                page={pagination.selectedPage - 1}
                                onChangePage={handleSelected}
                                rowsPerPage={enteriesPerPage}
                                />
                            ),
                            Body: (props) => (
                                <tbody><tr style={{ height: '49px' }}><td colspan="5" style={{ paddingTop: '0px', paddingBottom: '0px', textAlign: 'center' }}><span style={{ color: '#CC0000', fontWeight: '600' }}><FontAwesomeIcon icon={faTimes} /> Access Forbidden</span> </td></tr></tbody>
                            )
                        }
                    }
                />
            </div>
        </React.Fragment>
    );
}
export default UsersInGroup;